// 课程卡激活
export default [

  {
    path: '/acvitateLogin',
    component: () => import('@/pages/activationCourse/acvitateLogin.vue'),
  },
  {
    path: '/acvitateCourse',
    component: () => import('@/pages/activationCourse/acvitateCourse.vue'),
  },

];
